// extracted by mini-css-extract-plugin
module.exports = {"langItem":"styles_langItem__1E2eW","langItem_selected":"styles_langItem_selected__2GPJQ"};